import dayjs from 'dayjs';
const utc = require('dayjs/plugin/utc');
dayjs.extend(utc);
const currentDateFilter = {
  field: 'closeDate',
  value: `${dayjs().utc().startOf('day').format().replace('Z', '')}`,
  operator: 'DATE_GTE',
};
export default currentDateFilter;
